import type { ImagePrompt } from '@/app/types';

export const TEMP_IMAGE_URI_PREFIX = 'temp://';

export const isTempImageUri = (uri?: string | null): boolean => !!uri?.startsWith(TEMP_IMAGE_URI_PREFIX);

export const isUploadedImageUri = (uri?: string | null): boolean => !!uri && !isTempImageUri(uri);

export const hasUploadedSourceImage = (prompt?: ImagePrompt | null): boolean => isUploadedImageUri(prompt?.sourceImage);

export const hasUploadedImagePrompt = (prompt?: ImagePrompt | null): boolean =>
  !!prompt && hasUploadedSourceImage(prompt) && isUploadedImageUri(prompt.selectedImage);
